import { defineStore } from 'pinia'
import DeviceState, { DeviceStateType } from './state'
import { DeviceActions, DeviceActionsType } from './actions'
import { DeviceGetters } from './getters'

export const useDeviceStore = defineStore<
  'device',
  DeviceStateType,
  typeof DeviceGetters,
  DeviceActionsType
>('device', {
  state: DeviceState,
  actions: DeviceActions,
  getters: DeviceGetters,
})
